import { useField } from 'formik';
import React from 'react';
import {
  getImageDimensions,
  getImagefromBase64,
  handleFileRead,
  isValidImageSize,
  isValidImagetype,
} from '../../../utils/images';

const InputImage = (props) => {
  const [field, meta, helpers] = useField(props.name);

  const renderImage = () =>
    field.value.name
      ? getImagefromBase64(field.value)
      : field.value?.includes('http')
      ? field.value
      : null;

  const isThereImage = field.value?.name
    ? true
    : field.value?.includes('http')
    ? true
    : false;

  const onChange = async (e) => {
    const input = e.target;
    const files = input.files;
    const file = files && files[0];

    if (!file) {
      return;
    }

    helpers.setTouched(true);

    if (!isValidImageSize(file)) {
      helpers.setError('Asegúrate de que la imagen sea menor a 5MB');
      input.value = '';
      return;
    }

    if (!isValidImagetype(props.allowedExts, file)) {
      helpers.setError(
        `Asegúrate de que la imagen sea de formato ${props.allowedExts.join(
          ', '
        )}`
      );
      input.value = '';
      return;
    }

    if (props.expectedWidth && props.expectedHeight) {
      try {
        const { width, height } = await getImageDimensions(file);

        if (
          width !== props.expectedWidth ||
          height !== props.expectedHeight
        ) {
          helpers.setError(
            `La imagen debe medir exactamente ${props.expectedWidth}x${props.expectedHeight}px. La imagen seleccionada mide ${width}x${height}px.`
          );
          input.value = '';
          return;
        }
      } catch (error) {
        helpers.setError('No se pudieron validar las dimensiones de la imagen');
        input.value = '';
        return;
      }
    }

    const base64 = await handleFileRead(files);
    const uploadValue = props.fileNamePrefix
      ? { ...base64, name: `${props.fileNamePrefix}${base64.name}` }
      : base64;
    helpers.setError(undefined);
    helpers.setValue(uploadValue);
    input.value = '';
  };
  const icon = props.iconName || 'file_upload';
  const onClick = () => {
    helpers.setValue('');
  };
  return (
    <div
      className="input-image__container"
      onClick={() => helpers.setTouched(true)}
    >
      <label
        className={`${
          props.disabled ? 'input-image input-image--disabled' : 'input-image'
        }`}
        htmlFor={props.id}
      >
        <span className="material-symbols-outlined input-image__icon">
          {icon}
        </span>
        <span className="input-image__text">Cargar archivo</span>
      </label>
      <input
        type="file"
        name={props.name}
        className="input-image__field"
        id={props.id}
        onChange={(e) => onChange(e)}
        accept={props.allowedExts.join(',')}
        disabled={props.disabled}
      ></input>

      {isThereImage && (
        <div className="input-image__file-container">
          <div className="image-container">
            <img src={renderImage()} alt="imagen" />
            {!props.disabled && (
              <div className="image-eraser" onClick={onClick}>
                <span className="material-icons icon">close</span>
              </div>
            )}
          </div>
        </div>
      )}

      {meta.error && meta.touched && (
        <span className="error-message">{meta.error}</span>
      )}
    </div>
  );
};

export default InputImage;
